module.exports = __webpack_public_path__ + "static/blackcliff-warbow-8314c756e04ebbd6c9fce17aa4fbed71.png";